import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Sidebar = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [isItemDropdownOpen, setItemDropdownOpen] = useState(false);
  const [isPlatterDropdownOpen, setPlatterDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true }); // Redirect to login page after logout
  };

  return (
    <div className="bg-gray-800 text-white h-screen w-64 p-4 fixed">
      <h2 className="text-2xl font-bold mb-6">Ekhoni Khabo</h2>
      <h3 className="text-xl font-bold mb-2">Welcome</h3>
      <h3 className="mb-4">
        {user.firstName} {user.lastName} <span>({user.role})</span>
      </h3>
      <ul>
        <li>
          <Link to="/" className="block py-2 px-4 hover:bg-gray-700 rounded">
            Dashboard
          </Link>
        </li>
        <li>
          <Link
            to="/orders"
            className="block py-2 px-4 hover:bg-gray-700 rounded"
          >
            Orders
          </Link>
        </li>

        {/* <li>
          <Link
            to="/items"
            className="block py-2 px-4 hover:bg-gray-700 rounded"
          >
            Items
          </Link>
        </li> */}
        <li>
          <button
            onClick={() => setItemDropdownOpen(!isItemDropdownOpen)}
            className="block py-2 px-4 w-full text-left hover:bg-gray-700 rounded"
          >
            Items
          </button>
          {isItemDropdownOpen && (
            <ul className="ml-4">
              <li>
                <Link
                  to="/create-item"
                  className="block py-2 px-4 hover:bg-gray-700 rounded"
                >
                  Create Item
                </Link>
              </li>
              <li>
                <Link
                  to="/update-item"
                  className="block py-2 px-4 hover:bg-gray-700 rounded"
                >
                  Update Item
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/items/delete-item"
                  className="block py-2 px-4 hover:bg-gray-700 rounded"
                >
                  Delete Item
                </Link>
              </li> */}
            </ul>
          )}
        </li>
        <li>
          <button
            onClick={() => setPlatterDropdownOpen(!isPlatterDropdownOpen)}
            className="block py-2 px-4 w-full text-left hover:bg-gray-700 rounded"
          >
            Custom Platters
          </button>
          {isPlatterDropdownOpen && (
            <ul className="ml-4">
              <li>
                <Link
                  to="/create-platter"
                  className="block py-2 px-4 hover:bg-gray-700 rounded"
                >
                  Create platter
                </Link>
              </li>
              <li>
                <Link
                  to="/update-platter"
                  className="block py-2 px-4 hover:bg-gray-700 rounded"
                >
                  Update platter
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/items/delete-item"
                  className="block py-2 px-4 hover:bg-gray-700 rounded"
                >
                  Delete Item
                </Link>
              </li> */}
            </ul>
          )}
        </li>
        {user?.role === "super_admin" && (
          <li>
            <Link
              to="/create-admin"
              className="block py-2 px-4 hover:bg-gray-700 rounded"
            >
              Create Admin
            </Link>
          </li>
        )}
        <li>
          <button
            onClick={handleLogout}
            className="block py-2 px-4 w-full text-left hover:bg-gray-700 rounded"
          >
            Logout
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
